import styles from "../../pages/Community/CreateCommunityPage.module.css";
import TabsList from "./TabsList";
import GroupsList from "./GroupsList";
import VideoForm from "./VideoForm";
import VideosList from "./VideosList";

const VideoTabsManager = ({ videoTabsState, isSubmitting }) => {
  const {
    videoTabs,
    activeTabIndex,
    setActiveTabIndex,
    activeGroupIndex,
    setActiveGroupIndex,
    currentTab,
    setCurrentTab,
    editTabIndex,
    currentGroup,
    setCurrentGroup,
    editGroupIndex,
    currentVideo,
    setCurrentVideo,
    editVideoIndex,
    isVideoFree,
    setIsVideoFree,
    currentTabData,
    currentGroups,
    currentGroupData,
    currentVideos,
    setMembershipExpiry,
    clearMembershipExpiry,
    handleGroupBannerWebUpload,
    handleGroupBannerMobileUpload,
    handleAddOrUpdateTab,
    handleEditTab,
    handleDeleteTab,
    handleMoveTabUp,
    handleMoveTabDown,
    handleAddOrUpdateGroup,
    handleEditGroup,
    handleDeleteGroup,
    handleMoveGroupUp,
    handleMoveGroupDown,
    handleVideoCoverUpload,
    handleAddOrUpdateVideo,
    handleEditVideo,
    handleDeleteVideo,
    handleMoveVideoUp,
    handleMoveVideoDown,
    handleMembershipChange,
  } = videoTabsState;

  return (
    <div className={styles.sectionsWrapper}>
      <label className={styles.inlineLabel}>Video Tabs & Groups</label>

      {/* Tab Management */}
      <TabsList
        videoTabs={videoTabs}
        activeTabIndex={activeTabIndex}
        setActiveTabIndex={setActiveTabIndex}
        currentTab={currentTab}
        setCurrentTab={setCurrentTab}
        editTabIndex={editTabIndex}
        isSubmitting={isSubmitting}
        handleAddOrUpdateTab={handleAddOrUpdateTab}
        handleEditTab={handleEditTab}
        handleDeleteTab={handleDeleteTab}
        handleMoveTabUp={handleMoveTabUp}
        handleMoveTabDown={handleMoveTabDown}
      />

      {/* Group Management */}
      <GroupsList
        videoTabs={videoTabs}
        activeTabIndex={activeTabIndex}
        activeGroupIndex={activeGroupIndex}
        setActiveGroupIndex={setActiveGroupIndex}
        currentGroup={currentGroup}
        setCurrentGroup={setCurrentGroup}
        editGroupIndex={editGroupIndex}
        isSubmitting={isSubmitting}
        handleGroupBannerWebUpload={handleGroupBannerWebUpload}
        handleGroupBannerMobileUpload={handleGroupBannerMobileUpload}
        handleAddOrUpdateGroup={handleAddOrUpdateGroup}
        handleEditGroup={handleEditGroup}
        handleDeleteGroup={handleDeleteGroup}
        handleMoveGroupUp={handleMoveGroupUp}
        handleMoveGroupDown={handleMoveGroupDown}
      />

      {/* Video Management */}
      {currentGroups.length > 0 && (
        <div className={styles.sectionsCard}>
          <h4 className={styles.subSectionTitle}>
            Videos in "{currentGroupData?.group_title || "Selected Group"}"
          </h4>

          <VideoForm
            currentVideo={currentVideo}
            setCurrentVideo={setCurrentVideo}
            editVideoIndex={editVideoIndex}
            isVideoFree={isVideoFree}
            setIsVideoFree={setIsVideoFree}
            isSubmitting={isSubmitting}
            handleVideoCoverUpload={handleVideoCoverUpload}
            handleAddOrUpdateVideo={handleAddOrUpdateVideo}
            handleMembershipChange={handleMembershipChange}
            setMembershipExpiry={setMembershipExpiry}
            clearMembershipExpiry={clearMembershipExpiry}
          />

          <VideosList
            currentVideos={currentVideos}
            isSubmitting={isSubmitting}
            handleEditVideo={handleEditVideo}
            handleDeleteVideo={handleDeleteVideo}
            handleMoveVideoUp={handleMoveVideoUp}
            handleMoveVideoDown={handleMoveVideoDown}
          />
        </div>
      )}
    </div>
  );
};

export default VideoTabsManager;
